export const selectRegionsById = state =>
  state.RegionsReducer.regions.map(region => region.id);

export const selectRegions = state =>
  state.RegionsReducer.regions.reduce((ac, region) => {
    ac[region.id] = { ...region };
    return ac;
  }, {});

export const selectCountriesById = state =>
  state.RegionsReducer.countries.map(country => country.id);

export const selectCountries = state =>
  state.RegionsReducer.countries.reduce((ac, country) => {
    ac[country.id] = { ...country };
    return ac;
  }, {});

export const selectHoursConverted = hours => {
  const hoursObject = {};
  const isValidHours = str =>
    /^(\([0-9]{2}\))?(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(str);
  const isValidYN = string => /^[YN]{1}$/.test(string);
  for (const [key, value] of Object.entries<string>(hours)) {
    const valueHours =
      typeof value === 'string' ? value.substring(0, 5) : value;

    if (key.includes('Time')) {
      if (valueHours === '' || valueHours === null) {
        hoursObject[key] = null;
      } else if (isValidHours(valueHours)) {
        hoursObject[key] = valueHours;
      }
    }

    if (isValidYN(valueHours)) {
      hoursObject[key] = valueHours;
    }
  }
  return hoursObject;
};
